<template>
  <v-data-table
    hide-default-header
    hide-default-footer
    :headers='headers'
    :items='plants'
    class='rounded-0 elevation-1 row-pointer'
    :footer-props='{
        itemsPerPageOptions: [30],
      }'
    @click:row='onClick'
  >

    <template
      v-slot:header='{props}'
    >
      <th class='ps-4 pa-0' v-for='head in props.headers'>
        <p class='color-primary text-left pt-2 ps-0'>
          {{ head.text }}
        </p>
      </th>
    </template>

    <template v-slot:no-data>
      <p class='pa-0 ma-0 color-primary'>
        Нет доступных данных
      </p>
    </template>

    <template v-slot:footer.prepend>

    </template>

    <template v-slot:footer>
      <v-card tile elevation='0'>
        <v-card-text>
          страница {{ actualPage + 1 }} из {{ maxPage + 1 }}
          <v-btn @click='actualPage !== 0 ? onFirstPage() : null' icon
                 :class="actualPage === 0 ? 'v-btn--disabled' : ''">
            <v-icon color='blue'>mdi-chevron-double-left</v-icon>
          </v-btn>

          <v-btn @click='actualPage !== 0 ? onPrevious() : null' icon
                 :class="actualPage === 0 ? 'v-btn--disabled' : ''">
            <v-icon color='blue'>mdi-chevron-left</v-icon>
          </v-btn>

          <v-btn @click='actualPage !== maxPage ? onNext() : null' icon
                 :class="actualPage === maxPage ? 'v-btn--disabled' : ''">
            <v-icon color='blue'>mdi-chevron-right</v-icon>
          </v-btn>
        </v-card-text>


      </v-card>
    </template>

  </v-data-table>

</template>

<script>
export default {
  name: 'TableComponent',

  data() {
    return {
      headers: [
        {
          text: 'Штрихкод',
          align: 'start',
          sortable: false,
          value: 'barcode',
        },
        { text: 'Название на этикетке', value: 'labelName', sortable: false },
        { text: 'Название по Catalogue of Life', value: 'taxonomy', sortable: false },
        { text: 'Название по POWO', value: 'powotaxonomy', sortable: false },
        { text: 'Русское название', value: 'russianName', sortable: false },
        { text: 'Семейство', value: 'family', sortable: false },
        { text: 'Место сбора (обл., респ.)', value: 'gatheringPlaceRegion', sortable: false },
        { text: 'Место сбора (р-н)', value: 'gatheringPlaceDistrict', sortable: false },
        { text: 'Страна сбора', value: 'gatheringPlaceCountry', sortable: false },
      ],
    };
  },

  computed: {
    actualPage() {
      return this.page;
    },
  },

  props: {
    plants: {
      type: Array,
      required: true,
    },
    maxPage: {
      type: Number,
      required: true,
    },
    page: {
      type: Number,
      required: true,
    },
  },

  methods: {
    onClick(item, data) {
      let route = this.$router.resolve({ path: `/collections/${item.id}` });
      window.open(route.href);
    },

    onPrevious() {
      this.$emit('previousPage', this.page - 1);
    },

    onNext() {
      this.$emit('nextPage', this.page + 1);
    },

    onFirstPage() {
      this.$emit('changePage', 0);
    },

  },
};

</script>

<style scoped>
.row-pointer >>> tbody tr :hover {
    cursor: pointer;
}
</style>